"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidMonthsPeriod = void 0;
const luxon_1 = require("luxon");
const constants_1 = require("./constants");
const isValidMonthsPeriod = (startMonthLocal, endMonthLocal) => {
    const diff = luxon_1.Interval.fromDateTimes(startMonthLocal, endMonthLocal);
    const monthsPeriodDiff = diff.length("months");
    return monthsPeriodDiff > 0 && monthsPeriodDiff <= constants_1.MAX_MONTHS_PERIOD;
};
exports.isValidMonthsPeriod = isValidMonthsPeriod;
//# sourceMappingURL=is-valid-months-period.js.map